import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import DeleteImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DeleteImageSource';
import EditImageSource from 'hb-builder/components/common/SettingsLibrary/CommonSettings/EditImageSource';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import type { OnChangeSetting } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { HeroItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroItemAttributes';

import ImageArrangement from './ImageArrangement';

interface ImageBackgroundProps {
  item: DocumentItem<HeroItemAttributes>;
  isImageBackground: boolean;
  onChange: OnChangeSetting;
  canHeroBeFullWidth: boolean;
  canHaveRoundedCorner: boolean;
}

const ImageBackground = ({
  item,
  isImageBackground,
  onChange,
  canHeroBeFullWidth,
  canHaveRoundedCorner,
}: ImageBackgroundProps) => {
  const settingProps = { item, onChange };
  const { attributes, id } = item;
  const hasImage = Boolean(attributes?.containerBackgroundImage);

  const handleChangeImageSource = () => {
    onChange({
      id,
      settingKey: 'attributes.containerBackgroundImage',
    });
  };

  if (!isImageBackground) return null;

  return (
    <>
      <EditImageSource
        hasImage={hasImage}
        id={id}
        onModalOpen={handleChangeImageSource}
      />
      {hasImage && (
        <DeleteImageSource
          settingKey="attributes.containerBackgroundImage"
          {...settingProps}
        />
      )}
      <ImageArrangement {...settingProps} />
      <TextSetting
        settingKey="attributes.containerBackgroundImageAlt"
        title={__('Alternative text')}
        description={s__(
          "Builder|This will appear if the image can't be displayed",
        )}
        {...settingProps}
      />
      {canHeroBeFullWidth && (
        <CheckboxSetting
          settingKey="fullWidth"
          title={__('Full width background')}
          {...settingProps}
        />
      )}
      {canHaveRoundedCorner && !attributes?.fullWidth && (
        <NumberSetting
          settingKey="cornerRadius"
          title={__('Rounded corner')}
          {...settingProps}
        />
      )}
    </>
  );
};

export default ImageBackground;
